import { AuthErrorCodeKey } from 'shared/src/models/authErrorCode';
import { hideAppLoader } from 'shared/src/helpers/dom/domHelper';

let loadIncorrectPerson: (errorCode?: AuthErrorCodeKey) => void;
let loadOrganization: () => void;
let loadUser: () => void;
let loadDelegationUser: () => void;
let loadDelegationOrganization: () => void;
let loadWT: () => void;

// Development mode nie używa module federation, żeby umożliwić hot reload
// @ts-ignore
if (import.meta.env.MODE  === 'development') {
  loadUser = () => {
    // @ts-ignore
    import('https://localhost:8082/eus_user/src/createUserApp.ts');
  };

  loadOrganization = () => {
    // @ts-ignore
    import('https://localhost:8083/eus_organization/src/createOrganizationApp.ts');
  };

  loadDelegationUser = () => {
    // @ts-ignore
    import('https://localhost:8084/eus_delegation_user/src/createDelegationUserApp.ts');
  };

  loadDelegationOrganization = () => {
    // @ts-ignore
    import('https://localhost:8085/eus_delegation_organization/src/createDelegationOrganizationApp.ts');
  };

  loadWT = () => {
    // @ts-ignore
    import('https://localhost:8087/eus_wt/src/createWtApp.ts');
  };

  loadIncorrectPerson =  async (errorCode?: AuthErrorCodeKey) => {
    try {
      // @ts-ignore
      let module = await import('https://localhost:8102/incorrect_person/src/createIncorrectPersonApp.ts');
      const incorrectPersonApp = await module.default(errorCode);
      incorrectPersonApp.mount('#app');
    } catch (error) {
      console.error('Błąd podczas ładowania incorrectPerson:', error);
    } finally {
      hideAppLoader();
    }
  };
} else {
  loadUser = () => {
    import('eus_user/createUserApp');
  };

  loadOrganization = () => {
    import('eus_organization/createOrganizationApp');
  };

  loadDelegationUser = () => {
    import('eus_delegation_user/createDelegationUserApp');
  };

  loadDelegationOrganization = () => {
    import('eus_delegation_organization/createDelegationOrganizationApp');
  };

  loadWT = () => {
    import('eus_wt/createWtApp');
  };

  loadIncorrectPerson = (errorCode?: AuthErrorCodeKey) => {
    //@ts-ignore
    import('incorrect_person/createIncorrectPersonApp')
      .then(async (res) => {
        const incorrectPersonApp = await res.default(errorCode);
        if(!incorrectPersonApp) {
          throw new Error('incorrectPerson app instance not found');
        }
        incorrectPersonApp.mount('#app');
      })
      .catch(error => {
        console.log(error);
      })
      .finally(hideAppLoader);
  }
}

export { loadUser, loadOrganization, loadDelegationUser, loadDelegationOrganization, loadIncorrectPerson, loadWT }
